var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.405 6l-1.202 1.203 3.581 3.581H12.04v1.674h6.745l-3.581 3.581 1.202 1.203 5.02-5.02.575-.601-.575-.601L16.405 6zM2 10.784v1.674h1.673v-1.674H2zm3.346 0v1.674H7.02v-1.674H5.346zm3.347 0v1.674h1.673v-1.674H8.693z",
    id: "progression-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#progression-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgression);
export default __webpack_public_path__ + "static/media/progression.2f9ee1ace12dc82e0902bab0a3008991.svg";
export { ForwardRef as ReactComponent };